import axios from './axiosConfig';

const api = {
    // 获取所有工作地点
    listAllArea: () => axios.post('/area/listAreas'),
    // 根据条件获取岗位
    getPostListByParams: (limit, pn, recruitmentFaceToType, postTypeId, areaId, orgId, postName, postList) => axios.post('/post/listByParamsForPageFaceToWorker',
        {
            limit: limit,
            pageNum: pn,
            'params[recruitmentFaceToType]': recruitmentFaceToType,
            'params[postTypeId]': postTypeId,
            'params[areaId]': areaId,
            'params[orgId]': orgId,
            'params[postName]': postName,
            'params[postList]': postList
        }),
    // 根据ID获取岗位详情
    getDetailByPostId: (postId) => axios.post('/post/findById', { postId: postId })
};
export default api;
